import { Card} from "antd";


export interface PromocionMF {
  Cod_Promocion: number;
  Cod_Producto: number;
  Cantidad: number;
  Bonificacion: number;
  Fecha_Inicio: string;
  Fecha_Fin: any;
  Descuento: number;
  Observacion: string;
  Estado: string;
  Es_Acumulable: string;
  Retiene_Cajas: string;
  Codigo_Articulo: string;
  Laboratorio: string;
  Descripcion_MF: string;
  Proveedor: string;
  Dosis_Diaria: number;
  Descuento_Cadena: string;
  Venta_Minima: number;
  Dias_Acumulacion: number;
  Bonifiacion_por_año: number;
  Numero_De_Canjes: number;
  Agrupacion: string;
  Cod_Producto_Bonificacion: number;
  Descripcion_Producto_Bonificacion: string;
  Cantidad_Real: number;
  Bonificacion_Real: number;
  Es_Acumulable_Real: string;
  Datos_Completos: any | null;
  Descuento_Equivalente: any | null;
  Promocion_Monto: any | null;
  Es_Promocion_Lunes: number;
  Es_Promocion_Jueves: number;
  Es_Promocion_Martes: number;
  Es_Promocion_Miercoles: number;
  Es_Promocion_Viernes: number;
  Es_Promocion_Sabado: number;
  Es_Promocion_Domingo: number;
  Bonificacion2: number;
  Tipo_Promocion_A: string;
  Descuento_Farmacia: number;
}

const PromocionesMF = ({ promo }: { promo: PromocionMF | null }) => {
  const fechaFormateada = new Date(promo?.Fecha_Fin).toLocaleDateString("es-EC", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  return (
    <Card
      title={<div style={{ fontSize: 10, fontWeight: 700 }}>Promociones M.F.</div>}
      size='small'
      style={{ fontSize: "9px", margin: 0 }}
      headStyle={{ padding: "0px 4px", lineHeight: "2px", minHeight: "1px" }}
      bodyStyle={{ padding: 2 }}
    >
      <div style={{ color: "green", fontWeight: 500, fontSize: 9, height: 55 }}>
        {promo ? (
          promo.Descuento === 0 ? (
            <>
              {promo.Proveedor}&nbsp;
              <span>Hasta el {fechaFormateada}</span>
              <br />
              {promo.Tipo_Promocion_A}
              <br />
              {promo.Cantidad}&nbsp;&nbsp;{promo.Descripcion_MF} +
              <br />
              {promo.Bonificacion2}&nbsp;&nbsp;{promo.Descripcion_Producto_Bonificacion}
            </>
          ) : (
            <>
              {promo.Proveedor}&nbsp;
              <span>Hasta el {fechaFormateada}</span>
              <br />
              {`Descuento ` + promo.Descuento}
            </>
          )
        ) : (
          <>&nbsp;</>
        )}
      </div>
    </Card>
  );
};

export default PromocionesMF;
